import { Feedback } from 'types/Feedback';
import { useMutation } from '@tanstack/react-query';
import * as api from 'api/feedback';

export const useFeedback = (options: { onSuccess: () => void }) => {
  const createFeedbackMutation = useMutation({
    ...options,
    mutationFn: (body: Feedback) => api.createFeedback(body),
  });

  return {
    createFeedbackMutation,
  };
};
